import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useToast, useFetch, useAuth, useResource, useModal, useGrid, usePage } from "@/comn/hooks";
import { SG_BLL_ITM_LIST } from "../ntfc/services/OsciBllService";
import { URLS, SG_RCPT_BLL_DTL_LIST } from "./services/OsciRcptService"; // 서비스
import { APIS_COMN, SF_COMN_BLL_INFO, SF_COMN_BLL_SRCH } from "@/tz/go/egaz/osci/colt/comn/OsciColtComnService"; // 공통 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";

/*
 * Bill Detail
 * !== 고지 상세 ==!
 */
export const OSCI0402002Q = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { bllMgmtId, scrnTp, scrnId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    let pgeTitle = "";

    if (menuId?.includes("menu_osci0309")) {
        pgeTitle = "T_RCPT_ERR_DTL";
    } else {
        pgeTitle = "T_RCPT_DTL";
    }

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0056" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0058" },
            { area: "comnCd", comnCd: "OSC0065" },
            { area: "comnCd", comnCd: "OSC0067" },
            { area: "comnCd", comnCd: "OSC0072" },
            { area: "comnCd", comnCd: "OSC0018" },
            { area: "comnCd", comnCd: "OSC0023" },
            { area: "coCd" },
            { area: "bnkCd" },
        ],
    });

    const [vsbTansad, setVsbTansad] = useState(false);
    const [vsbBll, setVsbBll] = useState(false);
    const [vsbDspo, setVsbDspo] = useState(false);
    const [vsbRcpt, setVsbRcpt] = useState(false);
    const [vsdDtls, setVsdDtls] = useState(false);
    const [vsdErrs, setVsdErrs] = useState(false);
    const [vsdItms, setVsdItms] = useState(false);

    const [vsbRcptBtn, setVsbRcptBtn] = useState(false);
    const [vsbUpdtBtn, setVsbUpdtBtn] = useState(false);
    const [dsbUpdtBtn, setDsbUpdtBtn] = useState(false);
    const [dsbRcptBtn, setDsbRcptBtn] = useState(false);

    const [bllDtlList, setBllDtlList] = useState(comnUtils.getGridData([]));
    const [bllItmList, setBllItmList] = useState(comnUtils.getGridData([]));

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */

    const form = {
        // Bill Search !== 고지 검색 ==!
        bllSrch: useForm({
            defaultSchema: SF_COMN_BLL_SRCH,
            defaultValues: {},
        }),
        // Bill General !== 고지 일반 ==!
        bllGnrl: useForm({
            defaultSchema: SF_COMN_BLL_INFO,
            defaultValues: {},
        }),
    };

    const today = new Date();

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Detail List !== 고지 상세 목록 ==!
        bllDtlList: useGrid({
            defaultSchema: SG_RCPT_BLL_DTL_LIST,
        }),
        bllItmList: useGrid({
            defaultSchema: SG_BLL_ITM_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */

    const readyFunc = {
        noData: () => {
            form.bllGnrl.clearValues();
        },
        resetView: () => {
            setVsbBll(false);
            setVsbTansad(false);
            setVsbDspo(false);
            setVsbRcpt(false);
            setVsdDtls(false);
        },
        readyBll: (data: any) => {
            form.bllGnrl.setValues({
                ...data.bllInfo.content,
            });

            form.bllSrch.setValues({
                ...data.bllInfo.content,
            });

            if (data.bllInfo.content != null) {
                setVsbBll(true);
            }
            if (data.bllInfo.content.reffKeyTpCd == "T") {
                setVsbTansad(true);
            }
            if (data.bllInfo.content.bllStatCd == "F") {
                setVsbDspo(true);
            }
            if (data.bllInfo.content.bllStatCd == "C") {
                setVsbRcpt(true);
            }
            if (data.bllInfo.content.bllStatCd == "D" || data.bllInfo.content.bllSendStatCd == "F") {
                setVsdErrs(true);
            }

            if (data.bllInfo.content.reffKeyTpCd == null || data.bllInfo.content.reffKeyTpCd == "") {
                form.bllGnrl.setValue("reffKey", "");
            } else {
                if (data.bllInfo.content.reffKeyNo1) {
                    if (data.bllInfo.content.reffKeyTpCd == "T" || data.bllInfo.content.reffKeyTpCd == "B") {
                        form.bllGnrl.setValue(
                            "reffKey",
                            data.bllInfo.content.reffKeyNo1 +
                                "-" +
                                data.bllInfo.content.reffKeyNo2 +
                                "-" +
                                data.bllInfo.content.reffKeyNo3,
                        );
                    } else {
                        if (data.bllInfo.content.reffKeyNo4 == null || data.bllInfo.content.reffKeyNo4 == "") {
                            form.bllGnrl.setValue(
                                "reffKey",
                                data.bllInfo.content.reffKeyNo1 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo2 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo3,
                            );
                        } else {
                            form.bllGnrl.setValue(
                                "reffKey",
                                data.bllInfo.content.reffKeyNo1 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo2 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo3 +
                                    "-" +
                                    data.bllInfo.content.reffKeyNo4,
                            );
                        }
                    }
                }
            }

            if (data.bllInfo.content.dcltNm != null && data.bllInfo.content.dcltNm != "") {
                form.bllGnrl.setValue(
                    "dcltTinNm",
                    colUtils.setMask(data.bllInfo.content.dcltTin, "tin") + " (" + data.bllInfo.content.dcltNm + ")",
                );
            } else {
                form.bllGnrl.setValue("dcltTinNm", colUtils.setMask(data.bllInfo.content.dcltTin, "tin"));
            }

            if (data.bllInfo.content.exppnImppnNm != null && data.bllInfo.content.exppnImppnNm != "") {
                form.bllGnrl.setValue(
                    "exppnImppnTinNm",
                    colUtils.setMask(data.bllInfo.content.exppnImppnTin, "tin") +
                        " (" +
                        data.bllInfo.content.exppnImppnNm +
                        ")",
                );
            } else {
                form.bllGnrl.setValue("exppnImppnTinNm", colUtils.setMask(data.bllInfo.content.exppnImppnTin, "tin"));
            }

            if (data.bllInfo.content.pyerTpCd == "T") {
                if (data.bllInfo.content.pyerNm != null && data.bllInfo.content.pyerNm != "") {
                    form.bllGnrl.setValue(
                        "pyerMgmtNoNm",
                        colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin") +
                            " (" +
                            data.bllInfo.content.pyerNm +
                            ")",
                    );
                } else {
                    form.bllGnrl.setValue("pyerMgmtNoNm", colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin"));
                }
            } else {
                if (data.bllInfo.content.pyerMgmtNo == null || data.bllInfo.content.pyerMgmtNo == "") {
                    form.bllGnrl.setValue("pyerMgmtNoNm", data.bllInfo.content.pyerNm);
                } else {
                    if (data.bllInfo.content.pyerNm != null && data.bllInfo.content.pyerNm != "") {
                        form.bllGnrl.setValue(
                            "pyerMgmtNoNm",
                            colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin") +
                                " (" +
                                data.bllInfo.content.pyerNm +
                                ")",
                        );
                    } else {
                        form.bllGnrl.setValue("pyerMgmtNoNm", colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin"));
                    }
                }
            }

            if (data.bllInfo.content.bllRgsrId && data.bllInfo.content.bllRgsrNm) {
                form.bllGnrl.setValue(
                    "bllRgsrIdNm",
                    data.bllInfo.content.bllRgsrId + "/" + data.bllInfo.content.bllRgsrNm,
                );
            } else if (data.bllInfo.content.bllRgsrId) {
                form.bllGnrl.setValue("bllRgsrIdNm", data.bllInfo.content.bllRgsrId);
            } else if (data.bllInfo.content.bllRgsrNm) {
                form.bllGnrl.setValue("bllRgsrIdNm", data.bllInfo.content.bllRgsrNm);
            }

            if (data.bllInfo.content.bllTpCd && data.bllInfo.content.bllTpCd === "G") setVsdDtls(true);
            if (data.bllInfo.content.bllDtls) {
                setBllDtlList(comnUtils.getGridData(data.bllInfo.content.bllDtls));
            }

            if (data.bllInfo.content.bllItms && data.bllInfo.content.bllItms.length > 0) {
                setVsdItms(true);
                setBllItmList(comnUtils.getGridData(data.bllInfo.content.bllItms));
            }
        },
        readyBtn: (data: any) => {
            const bllStatCd = data.bllInfo.content.bllStatCd;
            const payMetdCd = data.bllInfo.content.payMetdCd;

            if (bllStatCd == "C") {
                // Receipt Completed
                setDsbRcptBtn(true);

                if (payMetdCd == "S" || payMetdCd == "N" || payMetdCd == "M") {
                    // to RG
                    setDsbUpdtBtn(true);
                } else {
                    if (payMetdCd == "C") {
                        // Cash Receipt
                        setDsbUpdtBtn(true);
                    } else if (payMetdCd == "U") {
                        // Manual Receipt
                        setDsbUpdtBtn(true);
                    } else if (payMetdCd == "B") {
                        setDsbUpdtBtn(true);
                    }
                }
            } else {
                setDsbUpdtBtn(true);
                setDsbRcptBtn(false);
            }
        },
    };

    const fetch = {
        // Get Bill !== 고지 조회 ==!
        getBll: useFetch({
            api: (data) => APIS_COMN.getBll(bllMgmtId),
            enabled: !!bllMgmtId,
            onSuccess: (data) => {
                readyFunc.readyBll(data);
                readyFunc.readyBtn(data);
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00182", // Please check Bill No.
                });
            },
            showToast: true,
        }),
        // Get Bill Search !== 고지 검색 조회 ==!
        getBllSrch: useFetch({
            api: (data) => APIS_COMN.getBllDtl(form.bllSrch.getValues()),
            onSuccess: (data) => {
                if (data.bllInfo.content != null) {
                    readyFunc.resetView();
                    readyFunc.readyBll(data);
                    readyFunc.readyBtn(data);
                } else {
                    toast.showToast({ type: "warning", content: "msg.osc.00050" });
                    readyFunc.noData();
                }
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00182", // Please check Bill No.
                });
            },
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getBllSrch: () => {
            form.bllSrch.handleSubmit((data) => {
                let bllNo = form.bllSrch.getValue("bllNo");
                let bllTpCd = form.bllSrch.getValue("bllTpCd");
                let bllSysmCd = form.bllSrch.getValue("bllSysmCd");
                let bllYy = form.bllSrch.getValue("bllYy");
                let bllSrno = form.bllSrch.getValue("bllSrno");
                let bllDgr = form.bllSrch.getValue("bllDgr");
                // Validation Check !== 밸리데이션 체크 ==!
                if (!!!bllNo && (!!!bllTpCd || !!!bllSysmCd || !!!bllYy || !!!bllSrno || !!!bllDgr)) {
                    modal.openModal({
                        content: "msg.osc.00281",
                    });
                } else {
                    fetch.getBllSrch.fetch();
                }
            })();
        },
    };

    const render = {
        grid_bllDtlList: {
            head: {},
            cell: {
                bllMgmtId: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <span>
                            {`${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`}
                        </span>
                    );
                },
            },
            edit: {},
        },
        grid_bllItmList: {
            head: {},
            cell: {},
            edit: {},
        },
    };

    useEffect(() => {
        form.bllSrch.setEditable(true);
        form.bllGnrl.setEditable(false);
    }, []);

    return (
        <Page title={t(pgeTitle)}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllSrch.schema.bllNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.bllSrch.schema.bllMgmtId}></Group.Label>
                            <Group.Field size={4}>
                                <Group.Control
                                    {...form.bllSrch.schema.bllTpCd}
                                    onPaste={(e: any) => {
                                        e.preventDefault();
                                        const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                        form.bllSrch.setValue("bllTpCd", data.substring(0, 1));
                                        form.bllSrch.setValue("bllSysmCd", data.substring(1, 5));
                                        form.bllSrch.setValue("bllYy", data.substring(5, 7));
                                        form.bllSrch.setValue("bllSrno", data.substring(7, 14));
                                        form.bllSrch.setValue("bllDgr", data.substring(14, 15));
                                    }}
                                />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllSysmCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllSrno} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllDgr} />
                            </Group.Field>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.bllSrch.reset();
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getBllSrch();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            {vsbTansad && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_TANSAD_GNRL"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.tansadNo} />
                                <Group.Control {...form.bllGnrl.schema.tansadDt} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.regm} />
                                <Group.Control {...form.bllGnrl.schema.csclPlnCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.exppnImppnTinNm} />
                                <Group.Control {...form.bllGnrl.schema.dcltTinNm} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.dclrPrcssSttsCd} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {vsbBll && (
                <>
                    <Group>
                        <Group.Body>
                            <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.bllNo} />
                                    <Group.Control {...form.bllGnrl.schema.bllDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.ctrlNo} />
                                    <Group.Control {...form.bllGnrl.schema.zmpDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.bllTpCdSec} />
                                    <Group.Control {...form.bllGnrl.schema.bllStatCd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.pyerMgmtNoNm} />
                                    <Group.Control {...form.bllGnrl.schema.bllRgsrIdNm} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.reffKeyTpCd} />
                                    <Group.Control {...form.bllGnrl.schema.reffKey} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.feeAmt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.payDdlnDt} />
                                    <Group.Control {...form.bllGnrl.schema.lastDdlnXtnsDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.xtnsDt} />
                                    <Group.Control {...form.bllGnrl.schema.lastDdlnXtnsRsn} />
                                </Group.Row>
                                {vsdErrs && (
                                    <Group.Row>
                                        <Group.Control {...form.bllGnrl.schema.errRcveDt} />
                                        <Group.Control {...form.bllGnrl.schema.errMsgCn} />
                                    </Group.Row>
                                )}
                            </Group.Section>
                        </Group.Body>
                    </Group>
                    {vsdDtls && (
                        <Group>
                            <Group.Body>
                                {" "}
                                <Layout direction="row">
                                    <Layout.Left>
                                        <Group.Title title={"T_BLL_DTL_1"} titleSize={2}></Group.Title>
                                    </Layout.Left>
                                </Layout>
                                <Grid {...grid.bllDtlList.grid} data={bllDtlList} render={render.grid_bllDtlList} />
                            </Group.Body>
                        </Group>
                    )}
                    {vsdItms && (
                        <Group>
                            <Group.Body>
                                {" "}
                                <Layout direction="row">
                                    <Layout.Left>
                                        <Group.Title title={"T_ITM_LST"} titleSize={2}></Group.Title>
                                    </Layout.Left>
                                </Layout>
                                <Grid {...grid.bllItmList.grid} data={bllItmList} render={render.grid_bllItmList} />
                            </Group.Body>
                        </Group>
                    )}
                </>
            )}
            {vsbDspo && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_BLL_CNCL"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.dspoDt} />
                                <Group.Control {...form.bllGnrl.schema.dspoCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.dspoRmrk} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {vsbRcpt && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_BLL_RCPT"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.payMetdCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.rcptBnkCd} />
                                <Group.Control {...form.bllGnrl.schema.rcptBnkAcctNo} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.rcptNo} />
                                <Group.Control {...form.bllGnrl.schema.manlRcptRsn} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.rcptAmt} />
                                <Group.Control {...form.bllGnrl.schema.rcptDt} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            if (scrnId == "OSCI0402003Q") {
                                navigate(URLS.osci0402003q);
                            } else if (scrnId == "OSCI0402004Q") {
                                navigate(URLS.osci0402004q);
                            } else {
                                navigate(URLS.osci0402001q);
                            }
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    {vsbRcptBtn && (
                        <Button
                            disabled={dsbRcptBtn}
                            onClick={() => {
                                navigate(
                                    `${URLS.osci0402007s}/new/${form.bllGnrl.getValues().bllTpCd}-${
                                        form.bllGnrl.getValues().bllSysmCd
                                    }-${form.bllGnrl.getValues().bllYy}-${form.bllGnrl.getValues().bllSrno}-${
                                        form.bllGnrl.getValues().bllDgr
                                    }-none/collection`,
                                );
                            }}
                        >
                            {t("B_RCPT")}
                        </Button>
                    )}
                    {vsbUpdtBtn && (
                        <Button
                            disabled={dsbUpdtBtn}
                            onClick={() => {
                                navigate(
                                    `${URLS.osci0402007s}/new/${form.bllGnrl.getValues().bllTpCd}-${
                                        form.bllGnrl.getValues().bllSysmCd
                                    }-${form.bllGnrl.getValues().bllYy}-${form.bllGnrl.getValues().bllSrno}-${
                                        form.bllGnrl.getValues().bllDgr
                                    }-none/collection`,
                                );
                            }}
                        >
                            {t("B_UPDT")}
                        </Button>
                    )}
                </Layout.Right>
            </Layout>
        </Page>
    );
};
